import { urlBinder } from "../../helper/url-binder";
import { IApiResponse } from "../../models/IAPIResponse";
import { IStudentInfo } from "../../models/student/studentAcademicProfile";
import APIService from "../../helper/api-service";
import { student } from "../../constants/apiUrl";

export default new (class StudentInfoService {
  public getStudentInfo = async (
    id: string
  ): Promise<IApiResponse<IStudentInfo>> => {
    try {
      let endPoint = urlBinder(student.STUDENT_INFO,[`${id}`])
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<IStudentInfo>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<IStudentInfo>;
      } else {
        throw error;
      }
    }
  };
});
